var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.925,
    fill: "white",
    stroke: "#1E1E2D",
    strokeWidth: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68936 3.77205C7.68936 4.8903 6.96488 5.85 6.00016 5.85C5.03469 5.85 4.31097 4.8903 4.31097 3.7717C4.31097 2.6538 4.93409 2 6.00016 2C7.06623 2 7.68936 2.65345 7.68936 3.77205ZM3.03544 8.3497C3.17996 8.51 3.80233 9 6.00016 9C8.19799 9 8.81999 8.51 8.96489 8.35005C8.97832 8.33468 8.98825 8.31691 8.99406 8.29783C8.99987 8.27875 9.00144 8.25876 8.99867 8.2391C8.96564 7.9304 8.66759 6.55 6.00016 6.55C3.33274 6.55 3.03469 7.9304 3.00128 8.2391C2.99856 8.25879 3.00019 8.27879 3.00606 8.29787C3.01194 8.31695 3.02193 8.33435 3.03544 8.3497Z",
    fill: "#1E1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarUserIcon);
export default __webpack_public_path__ + "static/media/avatar-user-icon.5ff6d781d51c4f9f35253aeb7f64105f.svg";
export { ForwardRef as ReactComponent };